<template>
  <div class='game-grid-item'>
    <div class='game-summary-header-container'>
      <div class='game-summary-header'>
        <div class='date'>{{game.name}}</div>
        <div class='links'>
          <div class='login'>
            <b-button @click="deleteGame" variant="outline" class="mb-2" size="sm"><b-icon icon="trash"></b-icon></b-button>
          </div>
        </div>
      </div>
    </div>
    <div class='game-summary-content-container'>
      <div class='game-summary-content'>
        <span v-if="game.completed == false">Current Round: {{currentRound}}</span><span v-else>Rounds Completed: {{currentRound}}</span>
          Players: {{game.roster | playernames}}
        <div v-if="hasWinner">
          <span v-if="game.completed">Winner</span><span v-else>Leader</span>: {{winner}}
        </div>
        <div>
          Started {{game.startDate | nicedate}}
            <b-button variant="primary" v-on:click="openGame()">
              <span v-if="game.completed == false">Continue Game</span>
              <span v-else>Review Game</span>
            </b-button>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
export default {
  name: "gamesummary",
  props: ["game"],
  methods: {
    openGame() {
    /* eslint-disable no-console */
        console.log('opening game ' + this.game.id)
        this.$store.dispatch('games/selectGame', {id: this.game.id})
        this.$router.push({ name: 'game-details', params: { game: this.game, id: this.game.id }})
    },
    deleteGame() {
        console.log('delete game ' + this.game.id)
      this.$store.dispatch('games/deleteGame', this.game.id)
    }
  },
  computed: {
    currentRound: function() {
      return this.game.currentRound
    },
    winner: function() {
      return this.game.winner
    },
    hasWinner: function() {
      return this.game.winner !== null
    }
  }
};
</script>

<style scoped>

.game-grid-item {
  width: 300px;
  height: 200px;
  margin: 15px;
  border: 1px solid #c9c9c9;
  border-radius: 6px;
  background-color: #f9fbfb;
  justify-content: flex-start;
  flex-direction: column;
}

.game-summary-header-container {
  color: #000;
  background-color: #c9c9c9;
  display: flex;
  justify-content: center;
  border-radius: 5px 5px 0px 0px;
  padding: 0px 5px 0px 5px;
  
}

.game-summary-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.game-summary-content-container {
  color: black;
  display: flex;
  justify-content: center;
  padding: 5px;
}

.game-summary-content {
  width: 900px;
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  margin: 5px;
}

.links {
  /*   border: 1px solid #fff;   */
  display: flex;
  justify-content: flex-end;
}

.login {
  margin-left: 20px;
}

</style>